/* eslint-disable */
import Swiper, { Navigation, Pagination, Autoplay, FreeMode } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Pagination]);

const loadSwiper = () => {
  const swiper = new Swiper('.default_slider.swiperPartners', {
    slidesPerView: 3,
    spaceBetween: 18,
    responsive: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    breakpoints: {
      680: {
        slidesPerView: 7,
        spaceBetween: 20,
      },
    },
  });
};

const loadSwiperBigger = () => {
  const swiper = new Swiper('.bigger_slider.swiperPartners', {
    slidesPerView: 2.2,
    spaceBetween: 18,
    responsive: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    breakpoints: {
      600: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      769: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  });
};

const loadPhotos = () => {
  new Swiper('.swiperPhotos', {
    slidesPerView: 2,
    spaceBetween: 0,
    responsive: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      680: {
        slidesPerView: 3,
      },
      1380: {
        slidesPerView: 4,
      },
      1600: {
        slidesPerView: 5,
      },
    },
  });
};

const loadSlideshow = () => {
  new Swiper('.swiperSlideshow', {
    slidesPerView: 1,
    responsive: true,
    spaceBetween: 40,
    autoHeight: true,
    navigation: {
      enabled: true,
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
};

const sliderContinuo = () => {
  new Swiper ('.sliderContinuo-swiper.swiper', {
    speed: 5000,
    slidesPerView: 2,
    spaceBetween: 20,
    loop: true,
    freemode: true,
    modules: [Autoplay, FreeMode],
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      425: {
        slidesPerView: 2.5,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 5.5,
      }
    },
  })
}

const sliderContinuoDepoimentos = () => {
  const pagination = document.querySelector('#sliderDepoimentos-pagination.swiper-pagination') ? document.querySelector('#sliderDepoimentos-pagination.swiper-pagination') : ',swiper-pagination';
  new Swiper ('.sliderDepoimentos-swiper.swiper', {
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 80,
    loop: true,
    freemode: true,
    modules: [Autoplay, FreeMode],
    autoplay: {
      delay: 30000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: pagination,
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      425: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 1,
      }
    },
  })
}

window.addEventListener('load', loadSwiper);
window.addEventListener('load', loadPhotos);
window.addEventListener('load', loadSlideshow);
window.addEventListener('load', sliderContinuo);
window.addEventListener('load', sliderContinuoDepoimentos);
window.addEventListener('load', loadSwiperBigger);
